var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-row',[_c('v-col',[_c('HeadMetadata',{attrs:{"title":_setup.pageTitle}}),_c(_setup.PageHeading,{attrs:{"heading":_setup.pageName}}),_c(_setup.SearchBar),_c(_setup.SearchResults,{staticClass:"mt-5 pt-5"})],1),_c(_setup.BriefcaseFolderMoveDialog)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }